/**
 * Users Routes
 */
/* eslint-disable */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// async components
import {
    AsyncPayslipManagementComponent,
    AsyncPayslipParamsManagementComponent
} from 'Components/AsyncComponent/AsyncComponent';

const Forms = ({ match }) => (
    <div className="content-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/payslip-management`} />
            <Route path={`${match.url}/payslip-management`} component={AsyncPayslipManagementComponent} />
            <Route path={`${match.url}/payslip-params-management`} component={AsyncPayslipParamsManagementComponent} />
        </Switch>
    </div>
);

export default Forms;
